module.exports = __webpack_public_path__ + "img/instyle-womens-fragrances.65e55fb7.png";